module.exports = __webpack_public_path__ + "static/media/Artikel_ChatGPT.689dad88.pdf";